module.exports = __webpack_public_path__ + "static/media/planning.69839a49.svg";